<template lang="pug">
.page-billing
  .container-form-billing
    .container-form__fields.container-form__fields--create

      iframe(v-if="showPaymentIframe" ref="paymentIframe" style="min-width: 320px; min-height: 900px; width: 100%; border: none; background-color: white;") Your browser does not support inline frames.

      template(v-else)
        .message-container(v-if="!valid && validationError")
          re-toast-alert(type="danger")
            template(v-slot:default="{alert}") {{ validationError }}

        .loader-container(v-else)
          .loader

    .container-form__fields--submit.form-field
      a.go-back(href="#" @click.prevent="gotoCart") Go back

</template>

<script>

const EventBus = window.VueEventBus

import PageMixins from '../../components/_mixins/pages'
import CartMixin from '../../components/_mixins/location-checkout'
import ScrollMixins from '../../components/_mixins/scroller'
import MainService from '../../services/main'

import {countries, states, DateTime} from '../../lib/utils'
import {ValidationMixins} from '../../lib/validations'
import axios from 'axios'
import Rollbar from 'rollbar'

const FIRSTDATA_FAIL_RC_CANCELLED = 5993

const ITEM_TYPES_WITH_3DS = ['gift_cards', 'playcard_voucher', 'playcard_reload']

export default {
  name: 'cart-billing',
  settings: 'page.cart.cart-billing',
  translations: 'page.cart.cart-billing',
  mixins: [
    PageMixins,
    CartMixin,
    ValidationMixins,
    ScrollMixins
  ],

  components: {},

  data: () => ({
    today: DateTime.local(),
    sources: {
      countries,
      states
    },
    fields: {
      first_name: '',
      last_name: '',
      address: '',
      city: '',
      zip: '',
      country: 'US',
      card: '',
      cvv: '',
      expMonth: '',
      expYear: '',
    },
    validations: {},
    isSubmitting: false,
    errors: {},
    // valid: false,
    // validationError: null,
    // costDetails: null,
    showPaymentIframe: false,
    transactionId: null,
    ipgTransactionId: null,
    rollbar: null,
  }),

  computed: {
    thisMonth() {
      return this.today.month
    },
    nextMonth() {
      return this.today.plus({months: 1})
    },
    expYears() {
      const years = []
      for (let i = this.nextMonth.year; i < this.nextMonth.year + 20; i++) {
        years.push(i)
      }
      return years
    },
    billingEnabled() {
      return this.costDetails.total > 0
    },
    isSubmitError() {
      return this.isBillingError
    },
    totals() {
      return this.billingTotal
    },
    guestEmail() {
      return this.billingGuestEmail
    },
    cardsInCartExist() {
      return Object.values(this.currentCartItems).find(item => ITEM_TYPES_WITH_3DS.includes(item.type))
    }
  },

  mounted() {
    this.setCartInvalid()
    this.setValidationError(null)

    if (this.isBillingError) {
      this.setValidationError('Unfortunately, there are issues with this transaction. Please try one more time later.')
      setTimeout(() => {
        this.setExpirationTimeBillingError(false)
        this.setValidationError(null)
      }, this.timeOutDisableBillingButton);
    } else {
      this.setExpirationTimeBillingError(false)

      this.showPaymentIframe = true
      this.$nextTick(() => {
        this.mountPaymentForm()
      })
    }
    this.$nextTick(() => {
      // console.log('mounted billing')
      this.scrollToTop()
    })
  },

  created() {
    this.setCostDetails(this.totals)

    EventBus.$on('cart.paid', (order) => {
      this.stopTimer()
      this.clearCartItems()
    })

    this.rollbar = new Rollbar({
      accessToken: window.addiesaas.config.rollbar.token,
      payload: {
        environment: window.addiesaas.config.env,
        person: {
          email: this.authUser ? this.authUser.email : this.guestEmail,
        }
      },
    })
  },

  beforeDestroy() {
    window.removeEventListener('message', this.receivePaymentFormMessage, false)
  },

  methods: {
    async mountPaymentForm() {
      const currentUrl = new URL(window.location.href)
      const redirect = currentUrl.origin + currentUrl.pathname

      const { data: paymentForm } = await axios.post(`${window.addiesaas.url}/api/customer/firstdata/iframe`, {
        amount: this.costDetails.total,
        redirect,
      })

      paymentForm.inputs.hostURI = currentUrl.origin

      if (this.cardsInCartExist) {
        paymentForm.inputs.threeDSRequestorChallengeIndicator = addiesaas.supercharged.firstdata.giftcard_3ds_requestor_challenge_indicator || '04'
      }

      const document = this.$refs.paymentIframe.contentDocument

      var newForm = document.createElement('form')
      newForm.setAttribute('method', 'post')
      newForm.setAttribute('action', paymentForm.action)
      for (const name in paymentForm.inputs) {
        const input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', name)
        input.setAttribute('value', paymentForm.inputs[name])
        newForm.appendChild(input)
      }
      document.body.appendChild(newForm)
      newForm.submit()

      window.addEventListener('message', this.receivePaymentFormMessage, false)
    },

    async receivePaymentFormMessage(event) {
      // console.log(event)
      if (event.origin == window.addiesaas.firstdata.base_url) {
        const data = event.data.elementArr.reduce(function (a, c) { a[c.name] = c.value; return a; }, {})
        // console.log(data)

        let transaction = null
        try {
          // TODO: Void from there by sending required response_code_3dsecure
          const { data: transactionData } = await axios.post(`${window.addiesaas.url}/api/customer/firstdata/transaction`, {
            email: this.authUser ? this.authUser.email : this.guestEmail,
            payload: data,
          })
          transaction = transactionData
        } catch (e) {
          this.rollbar.error(e);
        }

        try {
          if (data.status == 'APPROVED') {
            if (this.cardsInCartExist && data.response_code_3dsecure != 1) {
              this.setCartInvalid()
              this.setValidationError(window.addiesaas.config.translations.supercharged.transaction_not_authorized)
              this.$nextTick(() => {
                this.scrollToTop()
              })
              if (transaction) {
                axios.post(`${window.addiesaas.url}/api/customer/firstdata/transaction/${transaction.transaction_id}/void`)
              }
            } else {
              if (window.addiesaas.config.env != 'production') {
                this.simulateError()
              }

              this.transactionId = transaction ? transaction.transaction_id : null
              this.ipgTransactionId = data.ipgTransactionId

              const nameParts = data.bname.split(' ', 2)
              this.fields.first_name = nameParts[0] || ''
              this.fields.last_name = nameParts[1] || ''

              this.fields.card = data.ccbin + '000000' + data.cardnumber.slice(-4)
              this.fields.cvv = '000'
              this.fields.expMonth = data.expmonth
              this.fields.expYear = data.expyear

              this.fields.country = data.cccountry

              this.submit()
            }
          } else {
            if (data.fail_rc == FIRSTDATA_FAIL_RC_CANCELLED) {
              this.gotoCart()
            } else {
              this.setCartInvalid()

              let errorMessage = data.fail_reason || data.status
              if (errorMessage == 'Transaction declined. 3D Secure authentication failed.') {
                errorMessage = '3D Secure authentication failed, please try a different payment method.'
              }
              this.setValidationError(errorMessage)

              this.$nextTick(() => {
                this.scrollToTop()
              })
            }
          }
        } catch (e) {
          this.rollbar.error(e);
        }

        this.showPaymentIframe = false
      }
    },

    simulateError() {
      const searchParams = Object.fromEntries((new URL(window.location.href)).searchParams.entries())
      if (typeof searchParams.simulate_error !== 'undefined') {
        throw searchParams.simulate_error
      }
    },

    async submit() {
      this.formSubmitting = true
      this.setValidationError('')

      const payload = {
        items: Object.keys(this.currentCartItems).map(x => this.currentCartItems[x].payload),
        discounts: Object.keys(this.cartDiscounts).map(x => this.cartDiscounts[x].payload),
      }

      if (this.billingEnabled) {
        payload.payment = {
          transaction_id: this.transactionId,
          card: {
            extra: {
              transaction_id: this.ipgTransactionId,
            },
            number: this.fields.card,
            year: this.fields.expYear,
            month: this.fields.expMonth,
            code: this.fields.cvv,
            first_name: this.fields.first_name,
            last_name: this.fields.last_name,
          },
          billing: {
            zip: this.fields.zip,
            city: this.fields.city,
            country: this.fields.country,
          }
        }
      }

      if (!this.authUser) {
        payload.guest = {
          first_name: this.fields.first_name,
          last_name: this.fields.last_name,
          email: this.guestEmail,
          phone: '+1',
        }
      }

      this.isSubmitting = true

      try {
        EventBus.$emit('cart.paying', payload)
        let { data } = await axios.post(`${window.addiesaas.url}/api/customer/order`, payload)
        this.setCartValid()
        this.$emit('paid', data.data)
        EventBus.$emit('cart.paid', data.data)
        // this.stopTimer() // stop timer after payment is successful
        this.setBillingTotal(false)
        this.setBillingGuestEmail(false)
        this.setCheckoutState('final')
      } catch (e) {
        // this.errors = MainService.getErrorMessages(e)
        const message = MainService.getErrorMessage(e)
        this.isSubmitting = false
        this.setCartInvalid()
        if ((e.response && e.response.status !== 422) || message == 'Unknown error') {
          this.setExpirationTimeBillingError((new Date()).getTime())
          this.setValidationError((message != 'Unknown error') ? message : 'Unfortunately, there are issues with this transaction. Please try one more time later.')
          setTimeout(() => {
            this.setExpirationTimeBillingError(false)
            this.setValidationError(null)
          }, this.timeOutDisableBillingButton);
        } else {
          this.setValidationError(message)
        }
      }
    },

    gotoCart() {
      this.setBillingTotal(false)
      this.setBillingGuestEmail(false)
      this.setCheckoutState('cart')
    },
  }
}
</script>
